import { call, options, params } from './helpers';

export const exportInventory = (payload) =>
	call(`/beta/export/inventory`, options(payload, 'POST'), null, {
		csvResponse: true,
	});

export const exportTickets = (payload) =>
	call(`/beta/export/tickets`, options(payload, 'POST'), null, {
		csvResponse: true,
	});
